import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {BonusBunniesBonusMultiplierWPView} from "./BonusBunniesBonusMultiplierWPView";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {TimelineLite} from "gsap";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

/**
 * Created by Jerker Nord on 2019-09-05.
 */

export class BonusBunniesBonusMultiplierWPController extends WinPresentationController {

    private _totalBonusWinMultiplierBefore:number = 0;
    private _totalBonusWinMultiplierAfter:number = 0;
    private _multiplierUpdateTL:TimelineLite;
    private _isB5Win:boolean = false;
    private _view:BonusBunniesBonusMultiplierWPView;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusBunniesBonusMultiplierWPController", skippable : true});
        this._view = BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView = new BonusBunniesBonusMultiplierWPView();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        if(data.isRestoreState == true && data.mode == BonusBunniesGameMode.BONUS_GAME) {
            this._totalBonusWinMultiplierAfter = data.totalBonusWinMultiplierBefore;
        }
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._totalBonusWinMultiplierAfter = data.totalBonusWinMultiplierAfter;
        this._totalBonusWinMultiplierBefore = data.totalBonusWinMultiplierBefore;
    }

    protected hasWin():boolean {
        if(
            (this._totalBonusWinMultiplierAfter > 0) &&
            (this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) ||
            (this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME && this._gameData!.nextMode == BonusBunniesGameMode.NORMAL)) {
            return true;
        }
        return false;
    }

    public initMultiplierText():void{
        this._view.initMultiplierText(this._totalBonusWinMultiplierAfter);
    }

    protected startWinPresentation():void {
        if(this._multiplierUpdateTL && this._multiplierUpdateTL.isActive()) {
            this._multiplierUpdateTL.pause();
            this._multiplierUpdateTL.kill();
        }

        this._multiplierUpdateTL = new TimelineLite();
        if(this._totalBonusWinMultiplierAfter == this._view.currentMultiplierValue) {
            //No win round
            this._multiplierUpdateTL.add(() => this.finish(),"+=0.5");
        } else {
            if(this._isB5Win == false) {
                this._multiplierUpdateTL.add(this._view.setText(this._totalBonusWinMultiplierBefore, this._totalBonusWinMultiplierAfter, this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME), "+=0.5");
                this._multiplierUpdateTL.add(() => this.finish());
            } else {
                this._multiplierUpdateTL.add(() => this.finish(), "+=0.5");
            }
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._multiplierUpdateTL && this._multiplierUpdateTL.isActive()) {
                this._multiplierUpdateTL.pause();
                this._multiplierUpdateTL.kill();
            }
        }
        this._view.abortText(this._totalBonusWinMultiplierAfter, this._totalBonusWinMultiplierAfter, isAborted);
    }

    set isB5Win(value:boolean) {
        this._isB5Win = value;
    }
}